import * as angular from "angular";
import {IController} from "angular";

export class omsSpotsIndicationCtrl implements IController {
  orderPackages:number;

  $onInit() {
  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsSpotsIndication', {
    bindings: {
      orderPackages: '<?',
    },
    template: require('./oms-spots-indication.html').default,
    controller: omsSpotsIndicationCtrl
  });
